/**
 * StaffGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StaffData } from './staff_data'

/**
 * StaffGetRes
 */
export interface StaffGetRes {
  /** 员工详情 */
  items?: StaffData[]
}

/**
 * StaffGetRes Schema
 */
export const StaffGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '员工详情',
      format: '[]*model.StaffData',
      items: { $ref: 'StaffData', description: '' },
      type: 'array',
      label: '员工详情',
    },
  },
  type: 'object',
}
